"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCoreChartProps = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
exports.defaultCoreChartProps = {
    locale: "en-US",
    drillableItems: [],
    afterRender: noop_1.default,
    pushData: noop_1.default,
    onError: sdk_ui_1.defaultErrorHandler,
    onExportReady: noop_1.default,
    onLoadingChanged: noop_1.default,
    onDrill: function () { return true; },
    ErrorComponent: sdk_ui_1.ErrorComponent,
    LoadingComponent: sdk_ui_1.LoadingComponent,
};
//# sourceMappingURL=defaultProps.js.map